export interface JourneyRow {
  id: number
  start: string
  end: string
  submitterName: string
  departureDate: string | Date
  arrivalDate: string | Date
  status: string
  approverId: number
  travelType: 'Road Travel' | 'Air Travel'
}

export const mapJourneyToRow = (journey: any, isManagedView = false): JourneyRow => {
  const isAirJourney = Object.prototype.hasOwnProperty.call(journey, 'from')

  const start = isAirJourney ? journey.from : journey.departure_location
  const end = isAirJourney ? journey.to : journey.arrival_location
  const departureDate = isAirJourney ? journey.departure_date : journey.departure_time
  const arrivalDate = isAirJourney ? (journey.flight_departure_date || '') : journey.arrival_time
  const travelType = isAirJourney ? 'Air Travel' : 'Road Travel'

  const submitterName = `${journey.submitter.first_name} ${journey.submitter.final_name}`

  return {
    id: journey.id,
    start,
    end,
    submitterName,
    departureDate,
    arrivalDate,
    status: journey.status,
    approverId: journey.approver.id,
    travelType,
  }
}
